// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem-menuItem-zB-Up","isDisabled":"MenuItem-isDisabled-8EUVj"};